import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, Typography } from '@material-ui/core';
import { NoResultsIcon } from './NoResultsIcon';
const useStyles = makeStyles((theme) => ({
    icon: {
        marginBottom: theme.spacing(1),
    },
}));
export function NoResults() {
    const classes = useStyles();
    return (_jsxs("div", { "data-testid": 'data-grid-table-no-results', children: [_jsx(NoResultsIcon, { className: classes.icon }), _jsx(Typography, { component: 'h4', variant: 'h4', children: "No Results Found" }), _jsx(Typography, { component: 'p', variant: 'body1', children: "Try adjusting your search or filter to find what you\u2019re looking for." })] }));
}
